import { useHistory } from 'react-router';
import { useQuery } from 'utils/useQuery';

export default function CohortCumulativeSwitch() {
  const query = useQuery();
  const checked = query.get('cumulative') === 'false' ? false : true;

  const history = useHistory();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    query.set('cumulative', checked ? 'true' : 'false');

    history.push({ search: query.toString() });
  };
  return (
    <label className="text-base">
      <input
        className="mr-2 text-segments-accent-color-1 mb-1"
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
      Cumulative
    </label>
  );
}
